import { render } from "./MappingJobsView.vue?vue&type=template&id=1ddc56e6"
import script from "./MappingJobsView.vue?vue&type=script&lang=js"
export * from "./MappingJobsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__